import { useState, useEffect } from 'react';

export const useCountdown = (deadline, reminderMinutes, reminderTriggered) => {
  const [countdown, setCountdown] = useState(null);
  const [isOverdue, setIsOverdue] = useState(false);
  const [showCountdown, setShowCountdown] = useState(false);

  useEffect(() => {
    if (!deadline || !reminderTriggered) {
      setShowCountdown(false);
      return;
    }

    const updateCountdown = () => {
      const now = new Date();
      const deadlineDate = new Date(deadline);
      const diff = deadlineDate - now;

      if (diff <= 0) {
        const overdueDiff = Math.abs(diff);
        const hours = Math.floor(overdueDiff / (1000 * 60 * 60));
        const minutes = Math.floor((overdueDiff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((overdueDiff % (1000 * 60)) / 1000);
        setCountdown({ hours, minutes, seconds });
        setIsOverdue(true);
        setShowCountdown(true);
      } else {
        const hours = Math.floor(diff / (1000 * 60 * 60));
        const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diff % (1000 * 60)) / 1000);
        setCountdown({ hours, minutes, seconds });
        setIsOverdue(false);
        setShowCountdown(true);
      }
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, [deadline, reminderTriggered]);

  return { countdown, isOverdue, showCountdown };
};
